import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * This function assumes the caller wants to promote/demote the orchid pro in the caller's
 * practice group
 */
export default async function promoteOrDemoteToAdmin(
  targetOrchidProUserId: string,
  isPromoting: boolean, // true to promote, false to demote
) {
  const res = await fetchOrchidAPI(
    `/api/users/v1/practice_group/orchid_pro/${targetOrchidProUserId}/promote_or_demote_to_admin`,
    {
      method: "POST",
      body: JSON.stringify({
        is_promoting: isPromoting,
      }),
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    console.error(getErrorDetail(responseText));
  }
  return res;
}
